export const bookTypes = {
    SET_PAGE: 'SET_PAGE',
    SET_BOOK: 'SET_BOOK',
    SET_TOTAL_PAGE: 'SET_TOTAL_PAGE',
    SET_CATEGORY_BOOK: 'SET_CATEGORY_BOOK',
    SET_PUBLISHSER: 'SET_PUBLISHSER',
    SET_AUTHOR: 'SET_AUTHOR',
    ADD_CATEGORY_SUCCESS: 'ADD_CATEGORY_SUCCESS',
    ADD_CATEGORY_FAIL: 'ADD_CATEGORY_FAIL',
    UPDATE_CATEGORY_SUCCESS: 'UPDATE_CATEGORY_SUCCESS',
    UPDATE_CATEGORY_FAIL: 'UPDATE_CATEGORY_FAIL',
    RESET_CATEGORY: 'RESET_CATEGORY',
    ADD_AUTHOR_SUCCESS: 'ADD_AUTHOR_SUCCESS',
    ADD_AUTHOR_FAIL: 'ADD_AUTHOR_FAIL',
    UPDATE_AUTHOR_SUCCESS: 'UPDATE_AUTHOR_SUCCESS',
    UPDATE_AUTHOR_FAIL: 'UPDATE_AUTHOR_FAIL',
    RESET_AUTHOR: 'RESET_AUTHOR',
    ADD_PUBLISHER_SUCCESS: 'ADD_PUBLISHER_SUCCESS',
    ADD_PUBLISHER_FAIL: 'ADD_PUBLISHER_FAIL',
    UPDATE_PUBLISHER_SUCCESS: 'UPDATE_PUBLISHER_SUCCESS',
    UPDATE_PUBLISHER_FAIL: 'UPDATE_PUBLISHER_FAIL',
    RESET_PUBLISHER: 'RESET_PUBLISHER',
    ADD_BOOK_SUCCESS: 'ADD_BOOK_SUCCESS',
    ADD_BOOK_FAIL: 'ADD_BOOK_FAIL',
    UPDATE_BOOK_SUCCESS: 'UPDATE_BOOK_SUCCESS',
    UPDATE_BOOK_FAIL: 'UPDATE_BOOK_FAIL',
    RESET_BOOK: 'RESET_BOOK',
    AUTHOR_SET_PAGE: 'AUTHOR_SET_PAGE',
    AUTHOR_SET_TOTAL_PAGE: 'AUTHOR_SET_TOTAL_PAGE',
    CATEGORY_SET_PAGE: 'CATEGORY_SET_PAGE',
    CATEGORY_SET_TOTAL_PAGE: 'CATEGORY_SET_TOTAL_PAGE',
    PUBLISHER_SET_PAGE: 'PUBLISHER_SET_PAGE',
    PUBLISHER_SET_TOTAL_PAGE: 'PUBLISHER_SET_TOTAL_PAGE',
    BILL_SET_PAGE: 'BILL_SET_PAGE',
    BILL_SET_TOTAL_PAGE: 'BILL_SET_TOTAL_PAGE',
    BILL_SET_DATA: "BILL_SET_DATA",
    
    UPDATE_ISSEND_SUCCESS: 'UPDATE_ISSEND_SUCCESS',
    UPDATE_ISSEND_FAIL: 'UPDATE_ISSEND_FAIL',
}

export const userTypes = {
    SET_USER: 'SET_USER',
    ADD_USER_SUCCESS: 'ADD_USER_SUCCESS',
    ADD_USER_FAIL: 'ADD_USER_FAIL',
    UPDATE_USER_SUCCESS: 'UPDATE_USER_SUCCESS',
    UPDATE_USER_FAIL: 'UPDATE_USER_FAIL',
    RESET_USER: 'RESET_USER',
    LOGIN_SUCCESS: 'LOGIN_SUCCESS',
    LOGIN_FAIL: 'LOGIN_FAIL',
    SET_PAGE: 'SET_PAGE',
    SET_TOTAL_PAGE:'SET_TOTAL_PAGE'
}

export const homeTypes = {
    SET_TOP_PRODUCT:' SET_TOP_PRODUCT'
}